// *****************************************************************************
// Landing Module
// *****************************************************************************

document.addEventListener('DOMContentLoaded', () => {
  const landingModule = document.querySelector('.landing-module');
  if (!landingModule) return;

  const landingImages = document.querySelectorAll('.landing-module__image-list-item');
  const getRandomDuration = (min, max) => Math.random() * (max - min) + min;

  if (landingImages.length) {
    const controller = new ScrollMagic.Controller();
    landingImages.forEach((image, index) => {
      const parent = image.closest('.landing-module');
      const trigger = parent.querySelector('.landing-module__trigger');
      image.style.transitionDuration = `${getRandomDuration(0.6, 1.2)}s`;

      const moveY = [0, 3].includes(index) ? '20%' : '-40%';
      const heroAnimationTween = gsap.to(image, { y: moveY, ease: 'none', paused: true });

      new ScrollMagic.Scene({
        triggerElement: trigger,
        triggerHook: 0,
        duration: '100%',
      })
        .setTween(heroAnimationTween)
        .addTo(controller);
    });
  }
});
